/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from '../../helpers/graphQLShortcuts'
import Paragraph from "../Paragraph";
import {fieldObjectSectionStyleCss} from '../../helpers/createStyles';
import {filterHeadline, filterHTML} from "../../helpers/filters";
import './CenteredCallout.scss';

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldHtmlBody: string;
        fieldObjectSectionStyle: Array<{entity: Array}>;
        fieldObjectCta: Array<{targetRevisionId: string}>;
    }
}

class CenteredCalloutQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentCenteredCallout {
          fieldTxtHeadline
          fieldObjectCta {
            targetRevisionId
          }
          fieldHtmlBody {
            value
            format
            processed
          }
          fieldObjectSectionStyle {
              ${fieldObjectSectionStyle}
          }
        }
      }
    }
  }
}
`;

const CenteredCallout = ({id, markComponentLoadedAs, handleLoadedComponents}) => (
    <CenteredCalloutQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            const styles = fieldObjectSectionStyleCss(field.fieldObjectSectionStyle);

            // console.log(data)

            markComponentLoadedAs(id, true);

            return (
                <div className={`generalContent centeredCallout${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div className="generalContent__background" style={styles.childBackground.css}/>
                    )}
                    <div className="container">
                        {field.fieldTxtHeadline && (
                            <h2 className="centeredCallout__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                        )}

                        {field.fieldHtmlBody && field.fieldHtmlBody.processed && (
                            <div className="generalContent__body centeredCallout__body">
                                {filterHTML(field.fieldHtmlBody.processed, true)}
                            </div>
                        )}

                        {field.fieldObjectCta && (
                            <div className="generalContent__ctas centeredCallout__cta">
                                {field.fieldObjectCta.map(component => (
                                    <Paragraph key={`${id}_${component.targetRevisionId}`}
                                               id={String(component.targetRevisionId)}
                                               handleLoadedComponents={handleLoadedComponents}/>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            );
        }}
    </CenteredCalloutQuery>
);

CenteredCallout.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

export default CenteredCallout;



// WEBPACK FOOTER //
// ./frontend/components/CenteredCallout/CenteredCallout.jsx